module.exports = __webpack_public_path__ + "static/video-cooking-channel-a9e23c7b1942d6d09d3086a717385bb4.mp4";